export default "__VITE_ASSET__BD4hV4LL__"